export function can (permissionStore, permission) {
  return permissionStore.includes(permission)
}
